import styled from 'styled-components';

export const TypographyWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2.5)}px;
`;
